// extracted by mini-css-extract-plugin
export var searchHeader = "_7q-0";
export var searchHeaderDark = "_7q-1";